import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { getApiBaseUrl } from './utils/api';
import Icon from './Icon';
import './Sidebar.css';

const Sidebar = ({ onMenuClick }) => {
  const { user, selectedTenant, authenticatedFetch, hasPrivilege } = useAuth();
  const isAdmin = (user?.role || '').toLowerCase() === 'admin';
  const [showUtilization, setShowUtilization] = useState(false);

  useEffect(() => {
    const checkUtilizationAccess = async () => {
      if (!selectedTenant) {
        setShowUtilization(false);
        return;
      }

      try {
        const response = await authenticatedFetch(
          `${getApiBaseUrl()}/api/tenant-settings?tenant=${encodeURIComponent(selectedTenant.name)}`
        );
        if (response.ok) {
          const data = await response.json();
          const hasUBNT = Boolean(data.UBNTAPIKey && data.UBNTAPIKey.trim() &&
            data.UBNTAPIEndPoint && data.UBNTAPIEndPoint.trim());
          const hasFortiEndpoint = Boolean(data.FortiEndpoint && data.FortiEndpoint.trim());
          setShowUtilization(hasUBNT || hasFortiEndpoint);
        } else {
          setShowUtilization(false);
        }
      } catch (error) {
        console.error('Error checking utilization access:', error);
        setShowUtilization(false);
      }
    };

    checkUtilizationAccess();
  }, [selectedTenant, authenticatedFetch]);

  const handleMenuClick = (e, page) => {
    e.preventDefault();
    if (onMenuClick) {
      onMenuClick(page);
    }
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-inner">
        <nav className="sidebar-nav">
          <ul className="sidebar-links">
          {hasPrivilege('dashboard') && (
          <li>
            <a 
              href="#dashboard" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'dashboard')}
            >
              <Icon name="dashboard" size="small" className="sidebar-icon" />
              Dashboard
            </a>
          </li>
          )}
          {hasPrivilege('assets') && (
          <li>
            <a 
              href="#assets" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'assets')}
            >
              <Icon name="assets" size="small" className="sidebar-icon" />
              Assets
            </a>
          </li>
          )}
          {hasPrivilege('software') && (
          <li>
            <a 
              href="#software" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'software')}
            >
              <Icon name="software" size="small" className="sidebar-icon" />
              Software
            </a>
          </li>
          )}
          {hasPrivilege('tickets') && (
          <li>
            <a 
              href="#tickets" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'tickets')}
            >
              <Icon name="tickets" size="small" className="sidebar-icon" />
              Tickets
            </a>
          </li>
          )}
          {hasPrivilege('selfservice') && (
          <li>
            <a 
              href="#selfservice" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'selfservice')}
            >
              <Icon name="selfservice" size="small" className="sidebar-icon" />
              Self Service
            </a>
          </li>
          )}
          {hasPrivilege('analytics') && (
          <li>
            <a 
              href="#analytics" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'analytics')}
            >
              <Icon name="analytics" size="small" className="sidebar-icon" />
              Analytics
            </a>
          </li>
          )}
          {hasPrivilege('cisbenchmarks') && (
          <li>
            <a 
              href="#cisBenchmarks" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'cisBenchmarks')}
            >
              <Icon name="analytics" size="small" className="sidebar-icon" />
              CIS Benchmarks
            </a>
          </li>
          )}
          {isAdmin && hasPrivilege('documents') && (
            <li>
              <a 
                href="#documents" 
                className="sidebar-link"
                onClick={(e) => handleMenuClick(e, 'documents')}
              >
                <Icon name="license" size="small" className="sidebar-icon" />
                Documents
              </a>
            </li>
          )}
          {hasPrivilege('orders') && (
          <li>
            <a 
              href="#orders" 
              className="sidebar-link"
              onClick={(e) => handleMenuClick(e, 'orders')}
            >
              <Icon name="tickets" size="small" className="sidebar-icon" />
              Orders
            </a>
          </li>
          )}
          {showUtilization && hasPrivilege('utilization') && (
            <li>
              <a 
                href="#utilization" 
                className="sidebar-link"
                onClick={(e) => handleMenuClick(e, 'utilization')}
              >
                <Icon name="analytics" size="small" className="sidebar-icon" />
                Utilization
              </a>
            </li>
          )}
          </ul>
        </nav>
        <div className="sidebar-bottom">
          <img src="/SolidITlogo.png" alt="Solid IT" className="sidebar-logo" />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
